module.exports = __webpack_public_path__ + "static/self-8be9847e942eae840dd2bb5b09efdc71.jpg";